import { z } from 'zod';
/**
 * Xato kodlari — klient MATN bo'yicha emas, KOD bo'yicha ish ko'radi.
 *
 * Matn tarjima qilinadi va o'zgaradi; kod hech qachon o'zgarmaydi.
 * Yangi kod qo'shish — buzuvchi bo'lmagan o'zgarish; kodni o'chirish — buzuvchi.
 */
export const ERROR_CODES = {
    // --- umumiy ---
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    NOT_FOUND: 'NOT_FOUND',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    RATE_LIMITED: 'RATE_LIMITED',
    IDEMPOTENCY_CONFLICT: 'IDEMPOTENCY_CONFLICT',
    // --- autentifikatsiya / avtorizatsiya ---
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    INIT_DATA_INVALID: 'INIT_DATA_INVALID',
    INIT_DATA_EXPIRED: 'INIT_DATA_EXPIRED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_REVOKED: 'TOKEN_REVOKED',
    OTP_INVALID: 'OTP_INVALID',
    OTP_TOO_MANY_ATTEMPTS: 'OTP_TOO_MANY_ATTEMPTS',
    CREDENTIALS_INVALID: 'CREDENTIALS_INVALID',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    TWO_FACTOR_REQUIRED: 'TWO_FACTOR_REQUIRED',
    // --- katalog ---
    PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
    PRODUCT_NOT_AVAILABLE: 'PRODUCT_NOT_AVAILABLE',
    SKU_ALREADY_EXISTS: 'SKU_ALREADY_EXISTS',
    CATEGORY_HAS_CHILDREN: 'CATEGORY_HAS_CHILDREN',
    /**
     * Yaratishdagi qoidalar tahrirlashda ham amal qiladi. `Update` schemasi
     * qisman bo'lgani uchun Zod ularni ko'ra olmaydi — tekshiruv servisda,
     * natijaviy holat bo'yicha.
     */
    PRODUCT_INVALID_LEAD_TIME: 'PRODUCT_INVALID_LEAD_TIME',
    PRODUCT_INVALID_OLD_PRICE: 'PRODUCT_INVALID_OLD_PRICE',
    // --- savat va buyurtma ---
    CART_EMPTY: 'CART_EMPTY',
    CART_ITEM_NOT_FOUND: 'CART_ITEM_NOT_FOUND',
    INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
    ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
    SHIPMENT_NOT_FOUND: 'SHIPMENT_NOT_FOUND',
    TOO_MANY_SHIPMENTS: 'TOO_MANY_SHIPMENTS',
    // --- status ---
    INVALID_STATUS_TRANSITION: 'INVALID_STATUS_TRANSITION',
    COMMENT_REQUIRED: 'COMMENT_REQUIRED',
    ETA_REQUIRED: 'ETA_REQUIRED',
    // --- to'lov ---
    PAYMENT_NOT_FOUND: 'PAYMENT_NOT_FOUND',
    PAYMENT_ALREADY_CONFIRMED: 'PAYMENT_ALREADY_CONFIRMED',
    PAYMENT_ALREADY_REJECTED: 'PAYMENT_ALREADY_REJECTED',
    /// Qaror o'qilgan holatga nisbatan yoziladi; oraliqda boshqa qaror tushdi.
    PAYMENT_STATE_CHANGED: 'PAYMENT_STATE_CHANGED',
    /// `verifiedById` / `verifiedAt` siz, yoki CARD_TRANSFER da `bankRef` siz.
    PAYMENT_VERIFICATION_INCOMPLETE: 'PAYMENT_VERIFICATION_INCOMPLETE',
    PAYMENT_AMOUNT_INVALID: 'PAYMENT_AMOUNT_INVALID',
    PAYMENT_EXCEEDS_DUE: 'PAYMENT_EXCEEDS_DUE',
    // --- ma'lumotnoma ---
    /// `notify` yoqilgan, lekin `notifyTemplate` yo'q — push yaratilmaydi.
    NOTIFY_WITHOUT_TEMPLATE: 'NOTIFY_WITHOUT_TEMPLATE',
    // --- qidiruv ---
    SEARCH_UNAVAILABLE: 'SEARCH_UNAVAILABLE',
};
export const ERROR_CODE_LIST = Object.values(ERROR_CODES);
export const ErrorCodeSchema = z.enum(ERROR_CODE_LIST);
/**
 * Butun tizimda BITTA xato shakli. Har endpoint xatoda shuni qaytaradi.
 *
 * `details` — validatsiya xatolari kabi qo'shimcha ma'lumot. Ichida ichki
 * tafsilot (stack, SQL, ichki id) BO'LMAYDI.
 */
export const ErrorResponseSchema = z.object({
    code: ErrorCodeSchema,
    messageUz: z.string(),
    messageRu: z.string(),
    details: z.unknown().optional(),
    traceId: z.string(),
});
/** Validatsiya xatosining `details` shakli. */
export const ValidationDetailSchema = z.object({
    path: z.array(z.union([z.string(), z.number()])),
    message: z.string(),
});
//# sourceMappingURL=errors.js.map